import { FeatureFlagIds } from "../utils/featureFlagIds";
import React, { JSX, useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import Grid from '@mui/material/Grid';
import {
    Button,
    Card,
    CardContent,
    CircularProgress,
    IconButton,
    InputLabel,
    MenuItem,
    Select,
    Snackbar,
    SnackbarCloseReason,
    Tooltip
} from '@mui/material';
import MuiAlert, { AlertProps } from '@mui/material/Alert';
import LockNotice from './Shared/LockNotice';
import PrintIcon from '@mui/icons-material/Print';
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import RedoIcon from '@mui/icons-material/Redo';
import TagIcon from '@mui/icons-material/Tag';
import { IApplication } from '../Interfaces/Application/IApplication';
import { IAppStatus } from '../Interfaces/Application/IAppStatus';
import { IEmployeeRole } from '../Interfaces/Admin/IEmployeeRole';
import { IEmployee } from '../Interfaces/Admin/IEmployee';
import {
    caretAltLeftIcon,
    caretAltRightIcon,
    downloadIcon,
    printIcon
} from '@progress/kendo-svg-icons';
import {
    copyApplication,
    mergeApps,
    showErrorMessage,
    toggleEditingAppLock,
    unmergeApps,
    updateEditingApp
} from "../store/application/actions";
import {
    applicationCanBeReDeskedInStatus,
    applicationIsPastDesking,
    canUpdateApp,
    getAssignedEmployeeByRoleAndSequence,
    hasCobuyer,
    isAdmin,
    isSalesPerson    
} from '../utils/appUtils';
import MergeAppDialog from "./Views/OrderEditor/MergeAppDialog";
import NotesDialog from "./Views/OrderEditor/NotesDialog";
import { v4 } from 'uuid';
import {
    ApplicationDispatch,
    getDownPaymentHistories,
    SET_APP_DIRTY,
    SET_LOADING,
    SET_SERVER_MESSAGE,
    setShouldOpenGeneratePortalLinkDialog
} from '../store/application/types';
import {
    getCustomerPortalLinkMenuOptions,
    getOrdinalNumber,
    getTotalDownPaymentAmountPaid,
    saveFile,
    userHasPermission
} from '../utils/utils';
import { fetchFile } from '../Data/fetch';
import { useBusinessRulesEngine } from '../Data/BusinessRulesData';
import { showValidationDialog } from '../utils/ValidationDialog';
import { getApplicationDownloadMode } from '../utils/applicationDownload';
import CommentIcon from '@mui/icons-material/Comment';
import GetAppIcon from '@mui/icons-material/GetApp';
import LockIcon from '@mui/icons-material/Lock';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import HistoryIcon from '@mui/icons-material/History';
import MergeTypeIcon from '@mui/icons-material/MergeType';
import CallSplitIcon from '@mui/icons-material/CallSplit';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import Divider from '@mui/material/Divider';
import { addApplicationNotes } from '../Data/ApplicationData';
import { includes } from 'ramda';
import { useEmployeeRolePermissions } from '../Data/EmployeeRoleData';
import { useConfiguration } from '../Data/ConfigurationData';
import { Constants, permissions } from '../utils/constants';
import UnlockDialog from './Views/OrderEditor/UnlockDialog';
import { usePostedAppLock } from '../hooks/usePostedAppLock';
import { unlockApplicationSections, fetchActiveUnlock, relockApplication } from '../store/application/actions';
import { IApplicationAssignableRole } from "../Interfaces/Common/IApplicationAssignableRole";
import AssignableEmployeeSelect from "./Views/OrderEditor/AssignableEmployeeSelect";
import { IApplicationAssignment } from "../Interfaces/Application/IApplicationAssignment";
import produce from "immer";
import CardHeader from "@mui/material/CardHeader";
import InfoIcon from "@mui/icons-material/Info";
import { useDialog } from "../providers/DialogProvider";
import UnmergeAppDialog, { UnmergeAppDialogResult } from './Views/OrderEditor/UnmergeAppDialog';
import { IApplicationCustomerMergeInfo } from "../Interfaces/Common/IApplicationCustomerMergeInfo";
import { IUnmergeApplicationOptions } from '../Interfaces/Application/IUnmergeApplication';
import { ILoggedInEmployee } from '../Interfaces/Admin/ILoggedInEmployee';
import {
    ApplicationQuoteType, usesFinanceQuote,
    ContractType,
    CreateUpdateLoanPrintDocument,
    CreateUpdateLoanPrintDocumentPromptAnswer,
    DocumentInputType,
    DocumentPrintStepper,
    emptyLoanPrintData,
    expandPromptValuesToAnswers,
    FilledTemplateSubjectAndBody,
    getDistinctSelectedPromptIds,
    hasValue,
    IWhatWeOweItem,
    LinkType,
    LoadingPanel,
    LoanDocument,
    LoanPrintData,
    Organization,
    MessageTemplates,
    OwedToCustomerItem,
    PermissionSet,
    PromptIdValue,
    SimpleEmailMessage,
    SimpleMessagingDialog,
    SimpleTextMessage,
    toDollars,
    getStepIndices,
    NamedId,
    UpdateLoanPrint,
    addThousandsSeparator
} from '@amsanalytics/react-shared-library';
import { fetchConfig, httpGetAsync, httpPostAsync } from '../utils/HttpClient';
import { PrintContext } from '../Interfaces/Enums/PrintContext';
import { ICopyAppOptions } from "../Interfaces/Application/ICopyAppOptions";
import { CopyAppDialog, ICopyAppDialogResult } from "./Views/OrderEditor/CopyAppDialog";
import {
    generateCustomerPortalLink,
    getFilledTemplate,
    sendSimpleEmailMessagesToContact,
    sendSimpleTextMessagesToContact
} from "../utils/portalLinkUtils";
import LinkIcon from '@mui/icons-material/Link';
import { useNavigate } from 'react-router';
import { AppState } from '../store/rootReducer';
import { authService } from '..';
import { ILookupItems } from "../Interfaces/ILookupItems";
import { Window, WindowActionsBar, WindowActionsEvent } from '@progress/kendo-react-dialogs';
import { isNil } from 'ramda';
import { getBalanceOnQuote, getDownPaymentFromQuote, getLeaseAmountDueRefusal, getSelectedFinanceQuote, organizationAllowsQuoteType } from '../utils/quoteUtils';
import { assignableRolesForQuoteType } from '../utils/assignableRoleUtils';
import { SvgIcon } from '@progress/kendo-react-common';
import { Button as KendoButton } from "@progress/kendo-react-buttons";
import { Notification } from '@progress/kendo-react-notification';
import ConfirmationDialog from './Dialogs/ConfirmationDialog';
import { DownPaymentDialog } from "./Views/OrderEditor/DownPaymentDialog/DownPaymentDialog";
import { CardPaymentsWindow } from "./Views/OrderEditor/CardPayments/CardPaymentsWindow";
import { fetchDownPaymentCardChargesNow, useDownPaymentCardCharges } from "../Data/DownPaymentCardData";
import { unfinishedCardBarText, unfinishedCardPostingRefusal } from "../payments/downPaymentCards";
import ErrorDialog from "./Dialogs/ErrorDialog";
import {
    getAppQuoteByType,
    getDealerCheck,
    getDealerReserve
} from "./Quoters/IndirectQuoter/IndirectQuoterUtils";
import { IndirectQuoteType } from "../Data/IndirectQuoteType";
import {
    CustomerNumberReservationDialog
} from "./Dialogs/CustomerNumberReservationDialog/CustomerNumberReservationDialog";
import { ApplicationActivityRecord } from "../Interfaces/Application/ApiMessageHistory";
import { ApiMessageHistoryDialog } from "./Dialogs/ApiMessageHistoryDialog/ApiMessageHistoryDialog";
import { ZohoSignDialog } from "./Dialogs/ZohoSignDialog";
import { ESignHistoryDialog } from "./Dialogs/ESignHistoryDialog";
import PrintHistoryDialog from "./Dialogs/PrintHistoryDialog/PrintHistoryDialog";
import SecureCloseDialog from "./Dialogs/SecureCloseDialog/SecureCloseDialog";

/** Extends the shared LoanPrintData with fields the backend returns but the shared type hasn't added yet. */
interface LoanPrintDataResponse extends LoanPrintData {
    eligibleApplicationDocuments?: Array<{ id: number; name: string }>;
}

export interface ApplicationDetailsCardProps {
    updateApplication?: (fn: (app: IApplication) => IApplication | void) => void;
    salesPersonLabel?: string;
    preventDocumentDownload?: boolean;
    handleSaveAppFromOverview: (currentApp: IApplication, originalApplicationStatus: string, bypassAppRequirements: boolean) => Promise<void>;
}

const ApplicationDetailsCard = (props: ApplicationDetailsCardProps) => {
    // TODO: Need to convert all of these re-used strings to all use the same GUID id and then
    // create constants on client side. B.J. 2/19/2021
    const [showNotesDialog, setShowNotesDialog] = useState<boolean>(false);
    const [openDialog, closeDialog] = useDialog();
    const [isSnackbarOpen, setIsSnackbarOpen] = useState<boolean>(false);
    // whether or not to show the "Print Documents" window
    const [showPrintDocuments, setShowPrintDocuments] = useState<boolean>(false);
    // whether or not to show the ZohoSign e-signature dialog
    const [showZohoSignDialog, setShowZohoSignDialog] = useState<boolean>(false);
    // whether or not to show the SecureClose e-signature dialog
    const [showSecureCloseDialog, setShowSecureCloseDialog] = useState<boolean>(false);
    // whether or not to show the E-Sign History dialog
    const [showESignHistoryDialog, setShowESignHistoryDialog] = useState<boolean>(false);
    // whether or not to show the Print History dialog (mirrors Print Docs visibility)
    const [showPrintHistoryDialog, setShowPrintHistoryDialog] = useState<boolean>(false);
    // whether or not we are getting documents available for printing
    const [loadingPrintDocuments, setLoadingPrintDocuments] = useState<boolean>(false);
    // whether or not we are checking for always-printable documents
    const [checkingAlwaysPrintable, setCheckingAlwaysPrintable] = useState<boolean>(false);
    // Print availability state (loaded once when application changes)
    const [printAvailability, setPrintAvailability] = useState<{
        hasAlwaysPrintableDocs: boolean;
        hasApplicationContextDocuments: boolean;
    }>({
        hasAlwaysPrintableDocs: false,
        hasApplicationContextDocuments: false,
    });
    // whether or not we are currently loading the print preview
    const [loadingPrintPreview, setLoadingPrintPreview] = useState<boolean>(false);
    // whether or not the system is currently printing documents
    const [isPrintingLoanDocuments, setIsPrintingLoanDocuments] = useState<boolean>(false);
    // List of loan documents to be printed
    const [loanDocuments, setLoanDocuments] = useState<LoanDocument[]>([]);
    // List of loan document IDs to be printed
    const [selectedLoanDocumentIds, setSelectedLoanDocumentIds] = useState<string[]>([]);
    // List of PromptIdValue objects to be filled out when printing the document. Loop through each document and prompt to set the initial list of items.
    const [promptValues, setPromptValues] = useState<PromptIdValue[]>(getDistinctSelectedPromptIds(loanDocuments).map(promptId => ({ promptId, value: '' })));
    // Stage of the stepper window
    const [windowStage, setWindowStage] = useState<"DEFAULT" | "FULLSCREEN" | "MINIMIZED" | undefined>('FULLSCREEN');
    // Stepper index for the DocumentPrintStepper
    const [stepperIndex, setStepperIndex] = useState<number>(0);
    // PDF the user picked in this session (loan templates + selected Existing PDFs, no historical-union extras).
    // Drives the on-screen preview, the Kendo viewer's built-in download tool, and the toolbar's custom Print button.
    const [printPreviewPdf, setPrintPreviewPdf] = useState<string>('');
    // Combined PDF including historical-union extras the backend silently appends. This is the persisted package used
    // for Print History and the Documents tab so those surfaces stay byte-identical to today. The current-session
    // preview/download flow is driven by `printPreviewPdf`.
    const [combinedPrintPdf, setCombinedPrintPdf] = useState<string>('');
    // Loan Print information
    // Print order is admin-controlled and server-computed (loanDocumentsWithPrompts arrive in print order with
    // sortOrder set to the rank); nothing in this dialog reorders documents or groups.
    const [loanPrintData, setLoanPrintData] = useState<LoanPrintData>(emptyLoanPrintData);
    // List of all owed to customer items returned from the server when we get the loan documents.
    // This lets us "reset" the list of items if the user cancels the print process.
    const [allOwedToCustomerItems, setAllOwedToCustomerItems] = useState<OwedToCustomerItem[]>([]);
    // List of owed to customer items the user is currently editing
    const [owedToCustomerItems, setOwedToCustomerItems] = useState<OwedToCustomerItem[]>([]);
    // Existing PDF ApplicationDocuments eligible for inclusion in print output
    const [existingPdfs, setExistingPdfs] = useState<NamedId[]>([]);
    // IDs of existing PDFs selected by the user for inclusion in print output
    const [selectedExistingPdfIds, setSelectedExistingPdfIds] = useState<string[]>([]);
    // Compute dynamic step indices based on whether the "Existing PDFs" step should be shown
    const steps = getStepIndices({ showExistingPdfsStep: existingPdfs.length > 0, hideWhatWeOweStep: false });
    const currentApp: IApplication | undefined = useSelector((state: AppState) => state.applications.editingApp);
    const dispatch = useDispatch<ApplicationDispatch>();
    const appStatuses: IAppStatus[] = useSelector((state: AppState) => state.applications.appStatuses);
    const allOrganizations: Organization[] = useSelector((state: AppState) => state.applications.lookups.organizations);
    const employees: IEmployee[] = useSelector((state: AppState) => state.applications.employees);
    const employeeRoles: IEmployeeRole[] = useSelector((state: AppState) => state.applications.employeeRoles);
    const activeUser: ILoggedInEmployee = useSelector((state: AppState) => state.applications.loggedInUser!.employee);
    const applicationStatusWorkflows = useSelector((state: AppState) => state.applications.applicationStatusWorkflows);
    const currentEmployee = employees.find((e) => e.id === activeUser.id);
    const lookups: ILookupItems = useSelector((state: AppState) => state.applications.lookups);
    // The roles this application's quote type is assigned: a quote type's own row replaces the every-quote-type one.
    const applicationAssignableRoles: IApplicationAssignableRole[] = assignableRolesForQuoteType(lookups.applicationAssignableRoles, currentApp?.quoteType);
    const applicationAssignments: IApplicationAssignment[] = useSelector((state: AppState) => state.applications.editingApp?.applicationAssignments) ?? [];
    const navigate = useNavigate();
    const businessRulesEngine = useBusinessRulesEngine();
    const { data: configuration } = useConfiguration();
    const applicationDownloadMode = getApplicationDownloadMode(configuration);
    const showDownloadAppButton = props.preventDocumentDownload !== true && applicationDownloadMode !== 'hidden';
    const shouldOpenGeneratePortalLinkDialog = useSelector((state: AppState) => state.applications.shouldOpenGeneratePortalLinkDialog);
    const [isGeneratingCustomerPortalLink, setIsGeneratingCustomerPortalLink] = useState<boolean>(false);
    const embedCreditApplicationVersion = useSelector((state: AppState) => state.applications.lookups.embedCreditApplicationVersion);
    const applicationDownPaymentResponses = useSelector((state: AppState) => state.applications.applicationDownPaymentResponses);
    const lastSolvedSelectedFinanceQuote = useSelector((state: AppState) => state.applications.lastSolvedSelectedFinanceQuote);
    const updateAppStatus = (value: string) => {
        const updatedApp = produce(currentApp, (appToUpdate) => {
            appToUpdate!.appStatusId = value;
        });

        dispatch(updateEditingApp(updatedApp!, businessRulesEngine));
    }
    const [showDownPaymentDialog, setShowDownPaymentDialog] = useState<boolean>(false);
    // LOS card down payments A12, A13: the application's card rows (shared with Down Payment History through
    // react-query), the bar while one isn't in AMS yet, and the Card payments window. They live here because this card
    // shows in every overview layout.
    const [showCardPayments, setShowCardPayments] = useState<boolean>(false);
    const { data: cardCharges } = useDownPaymentCardCharges(currentApp?.id);
    const unfinishedCardBar = unfinishedCardBarText(cardCharges);
    const previousAmsLoans = useSelector((state: AppState) => state.applications.previousAmsLoans);
    const isSuperUser: boolean = configuration?.isSuperUser ?? false;

    const onDownPaymentClose = () => {
        setShowDownPaymentDialog(false);
        // Wait 2 seconds before refreshing down payments from AMS to allow the payment to process
        if (currentApp) {
            setTimeout(() => {
                dispatch(getDownPaymentHistories(currentApp.id));
            }, 2000);
        }
    };

    const openDownPaymentDialog = () => {
        // B1, B3: a lease collects Total Down less deferred down, which needs a solved quote whose Total Down covers the
        // deferred down payments.
        const leaseRefusal = currentApp?.quoteType === ApplicationQuoteType.Lease
            ? getLeaseAmountDueRefusal(currentApp.applicationLeaseQuote)
            : undefined;
        if (!hasValue(activeUser.employeeNumber)) {
            openDialog({
                children: (
                    <ErrorDialog
                        title="Employee Number Required"
                        errors={['Your employee record must have an AMS 2000 employee number attached to it before you can make a down payment']}
                        closeDialog={() => {
                            closeDialog();
                        }}
                    />
                ),
            });
        } else if (usesFinanceQuote(currentApp?.quoteType) && lastSolvedSelectedFinanceQuote?.contractType === ContractType.SinglePayment) {
            openDialog({
                children: (
                    <ErrorDialog
                        title="Cash Deal"
                        errors={['Down payments are not allowed on cash deals. Please update the contract type and solve again.']}
                        closeDialog={() => {
                            closeDialog();
                        }}
                    />
                ),
            });
        } else if (leaseRefusal) {
            openDialog({
                children: (
                    <ErrorDialog
                        title="Lease Total Down"
                        errors={[leaseRefusal]}
                        closeDialog={() => {
                            closeDialog();
                        }}
                    />
                ),
            });
        } else if (downPaymentOnQuote === 0) {
            openDialog({
                children: (
                    <ErrorDialog
                        title="No Down Payment on Quote"
                        errors={['Down payments are not allowed to be made on a quote with a down payment of $0']}
                        closeDialog={() => {
                            closeDialog();
                        }}
                    />
                ),
            });
        } else if (!applicantOwesMoreDownPayment) {
            openDialog({
                children: (
                    <ErrorDialog
                        title="Total Down Payment Amount Paid"
                        errors={[`The down payment on the quote, ${toDollars(downPaymentOnQuote)}, has already been paid`]}
                        closeDialog={() => {
                            closeDialog();
                        }}
                    />
                ),
            });
        } else {
            dispatch(getDownPaymentHistories(currentApp!.id));
            setShowDownPaymentDialog(true);
        }
    }

    const getEmployeesByRole = (roleId: string): IEmployee[] => {
        return employees.filter(employee => includes(roleId.toLowerCase(), employee?.employeeEmployeeRoles?.map(eer => eer.employeeRoleId.toLowerCase()) ?? []));
    }

    const updateLocation = (value: string) => {
        const app = produce(currentApp, (currentApp) => {
            currentApp!.organizationId = value;

            const newOrganization = allOrganizations.find(o => o.id === value);

            const underwriterQuote = getAppQuoteByType(currentApp, IndirectQuoteType.Underwriter);
            if (underwriterQuote) {
                underwriterQuote.quote.dealerPartialPercent = newOrganization?.reservePercent;
                underwriterQuote.quote.dealerReserve = getDealerReserve(underwriterQuote.quote);
                underwriterQuote.quote.dealerCheck = getDealerCheck(underwriterQuote.quote);
            }
        });

        dispatch(updateEditingApp(app!, businessRulesEngine));
    }

    const handleMerge = (bypassAppRequirements?: boolean) => {
        const result = businessRulesEngine({
            action: "Merge",
        });
        if (result?.errors?.length && !bypassAppRequirements) {
            showValidationDialog({
                errors: result.errors,
                callback: () => handleMerge(true),
            });
        } else {
            openDialog({
                fullScreen: false,
                children: <MergeAppDialog
                    onOK={(applicantsToMerge: IApplicationCustomerMergeInfo[]) => mergeApp(applicantsToMerge)}
                    closeDialog={closeDialog}
                />
            })
        }
    }

    const handleUnmerge = (bypassAppRequirements?: boolean) => {
        const result = businessRulesEngine({
            action: "Unmerge",
        });
        if (result?.errors?.length && !bypassAppRequirements) {
            showValidationDialog({
                errors: result.errors,
                callback: () => handleUnmerge(true),
            });
        } else {
            openDialog({
                fullScreen: false,
                children: <UnmergeAppDialog
                    applicationNumber={currentApp!.applicationNo}
                    appCustomers={currentApp?.appCustomers || []}
                    onConfirm={(result: UnmergeAppDialogResult) => {
                        unmergeApp({ ...result, applicationId: currentApp!.id });
                        closeDialog();
                    }}
                    closeDialog={closeDialog}
                />
            })
        }
    }

    const handleCopy = (bypassAppRequirements?: boolean) => {
        const result = businessRulesEngine({
            action: "Copy Application",
        });
        if (result?.errors?.length && !bypassAppRequirements) {
            showValidationDialog({
                errors: result.errors,
                callback: () => handleCopy(true),
            });
        } else {
            openDialog({
                fullScreen: false,
                children: <CopyAppDialog
                    applicationNumber={currentApp!.applicationNo}
                    applicationId={currentApp!.id}
                    organizations={allOrganizations}
                    onConfirm={async (result: ICopyAppDialogResult) => {
                        copyApp({ ...result, applicationId: currentApp!.id });
                        closeDialog();
                    }}
                    closeDialog={closeDialog}
                />
            })
        }
    }

    const handleAddNotes = (notes: { note: string, isDecisionNote: boolean, createdDate: Date }[], bypassAppRequirements?: boolean): void => {
        const result = businessRulesEngine({
            action: "Notes",
        });
        if (result?.errors?.length && !bypassAppRequirements) {
            showValidationDialog({
                errors: result.errors,
                callback: () => handleAddNotes(notes, true),
            });
        } else {
            addApplicationNotes(currentApp!.id, notes, dispatch);
            setShowNotesDialog(false);
        }
    };

    const mergeApp = async (applicantsToMerge: IApplicationCustomerMergeInfo[]) => {
        dispatch({ type: SET_LOADING, payload: true });
        const result = await dispatch(mergeApps(applicantsToMerge));
        dispatch({ type: SET_APP_DIRTY, payload: false });
        dispatch({ type: SET_LOADING, payload: false });

        if (result.success) {
            navigate(`/order/${result.newApplicationId}`);
        }
    }

    const unmergeApp = async (unmergeOptions: IUnmergeApplicationOptions) => {
        dispatch({ type: SET_LOADING, payload: true });
        const result = await dispatch(unmergeApps(unmergeOptions));
        dispatch({ type: SET_APP_DIRTY, payload: false });
        dispatch({ type: SET_LOADING, payload: false });

        if (result.success) {
            navigate(`/order/${result.newActiveApplicationId}`);
        }
    }

    const copyApp = async (copyOptions: ICopyAppOptions) => {
        dispatch({ type: SET_LOADING, payload: true });
        const result = await dispatch(copyApplication(copyOptions));
        dispatch({ type: SET_APP_DIRTY, payload: false });
        dispatch({ type: SET_LOADING, payload: false });

        if (result.success) {
            navigate(`/order/${result.newActiveApplicationId}`);
        }
    }

    const pdfApp = async (bypassAppRequirements?: boolean) => {
        if (!currentApp) return;
        const result = businessRulesEngine({
            action: "Download App PDF",
        });
        if (result?.errors?.length && !bypassAppRequirements) {
            showValidationDialog({
                errors: result.errors,
                callback: () => pdfApp(true),
            });
        } else {
            try {
                dispatch({ type: SET_LOADING, payload: true });
                const response = await fetchFile(`api/pdf/${currentApp.id}`, dispatch);
                if (response.ok) {
                    await saveFile(response, 'application.pdf');
                } else {
                    dispatch({
                        type: SET_SERVER_MESSAGE, payload: {
                            isError: true,
                            message: "Error retrieving PDF",
                        }
                    });
                }
            } finally {
                dispatch({ type: SET_LOADING, payload: false });
            }
        }
    }

    const getApplicationReport = async () => {
        // get token
        const bearerToken = await authService.getToken();
        // get config and base url
        const config: any = await fetchConfig();
        const baseUrl = `${config.api_endpoint}`;
        const applicationReport = await httpPostAsync(`api/reporting/getReport`,
            {
                reportName: configuration?.applicationReport,
                reportParameters: [{
                    name: "AppNumber",
                    value: currentApp?.applicationNo,
                },
                ],
                reportFormat: "1",
                downloadName: `Application_${currentApp?.applicationNo ?? ''}.pdf`
            }, bearerToken!);

        // Save PDF
        await saveFile(applicationReport!, 'applicationReport.pdf');
    }

    // ─── Posted App Unlock ────────────────────────────────────────────
    const [showUnlockDialog, setShowUnlockDialog] = useState(false);
    const { isPostedAndLocked, isReadOnlyLoanSideDeal, lockMessage, activeUnlock, isSectionLocked, lockedTooltip } = usePostedAppLock();

    const toggleAppLock = () => {
        if (isPostedAndLocked && !currentApp?.unlockedBySuperUser) {
            // For posted/locked apps, open the granular unlock dialog
            if (activeUnlock) {
                // Already unlocked — re-lock
                if (currentApp) dispatch(relockApplication(currentApp.id));
            } else {
                setShowUnlockDialog(true);
            }
        } else if (!currentApp?.unlockedBySuperUser) {
            // Legacy toggle for non-posted locked statuses
            dispatch(toggleEditingAppLock());
        }
    };

    const handleUnlockSubmit = (applicationId: string, sections: string[], reason?: string) => {
        dispatch(unlockApplicationSections(applicationId, sections, reason));
        setShowUnlockDialog(false);
    };

    // Fetch active unlock when app loads
    useEffect(() => {
        if (currentApp?.id && isPostedAndLocked && !isReadOnlyLoanSideDeal) {
            dispatch(fetchActiveUnlock(currentApp.id));
        }
    }, [currentApp?.id, isPostedAndLocked, isReadOnlyLoanSideDeal, dispatch]);

    const [canView, canEdit, canAct] = useEmployeeRolePermissions();

    // Nothing unlocks a refinance or side note: DealerFlow 360 works it.
    const canUnlockApp = !isReadOnlyLoanSideDeal && (isAdmin(activeUser)
        || canAct('Actions', 'Unlock App')
        || userHasPermission(activeUser, permissions.unlockPostedApplication, PermissionSet.U));

    const isCurrentlyUnlocked = !!currentApp?.unlockedBySuperUser || !!activeUnlock;
    const unlockButtonColor = isCurrentlyUnlocked ? '#f50057' : '#757575';

    function Alert(props: AlertProps) {
        return <MuiAlert elevation={6} variant="filled" {...props} />;
    }

    // Gets all available employees for that role and makes sure that the currently assigned user is
    // still assigned even if they're not in that role any longer
    const getValidEmployeesByRole = (currentEmployeeId: string, roleId: string) => {
        let validEmployees = getEmployeesByRole(roleId);

        // Also adds the credit managers the underwriter assignable list
        if (roleId === Constants.roles.underwriterId) {
            validEmployees.push(...getEmployeesByRole(Constants.roles.creditManagerId));
        }
        // Also adds the investigator managers the investigator assignable list
        if (roleId === Constants.roles.investigatorId) {
            validEmployees.push(...getEmployeesByRole(Constants.roles.investigatorManagerId));
        }
        // Also adds the collections managers to the collector assignable list
        if (roleId === Constants.roles.collectorId) {
            validEmployees.push(...getEmployeesByRole(Constants.roles.collectionsManagerId));
        }
        // Someone in both roles is listed once.
        validEmployees = validEmployees.filter((employee, index, all) => all.findIndex(other => other.id === employee.id) === index);

        const selectedEmployee = employees.find(e => e.id === currentEmployeeId);

        // Make sure to include any currently assigned employee (even if they are no longer active in that role...)
        if (selectedEmployee && !validEmployees.some(ve => ve.id === selectedEmployee.id)) {
            const duplicateIndex = validEmployees.findIndex(ve =>
                ve.firstName === selectedEmployee?.firstName
                && ve.lastName === selectedEmployee?.lastName);
            if (duplicateIndex >= 0) {
                validEmployees.splice(duplicateIndex, 1);
            }
            validEmployees.push(selectedEmployee);
        }
        return validEmployees;
    };

    // Who is in the slot; an emptied slot (the empty id a quote type change leaves) reads as "(unassigned)".
    const assignedEmployeeIdForSlot = (roleId: string, sequence: number): string => {
        const assignedToId = getAssignedEmployeeByRoleAndSequence(applicationAssignments, roleId, sequence)?.assignedToId ?? '';
        return assignedToId === Constants.emptyGuid ? '' : assignedToId;
    };

    const canAssignRole = (assignableRoleId: string) => {
        const employeeRole = employeeRoles.find(er => er.id.toLowerCase() === assignableRoleId.toLowerCase());

        if (!employeeRole) {
            return false;
        }

        return canAct('Actions', `Assign ${employeeRole.name}`);
    };

    const isMergeable = currentApp && configuration && (!configuration.mergeableStatuses || configuration.mergeableStatuses.includes(currentApp?.appStatusId));

    const getActivityHistoryForApplication = async (applicationId: string): Promise<ApplicationActivityRecord[] | undefined> => {
        // get token
        const bearerToken = await authService.getToken();
        const activityHistory: Response | undefined = await httpGetAsync(`api/ApiMessageHistory/GetActivityHistory/?applicationId=${applicationId}`, bearerToken!);
        if (isNil(activityHistory)) {
            dispatch(showErrorMessage(`Did not find any activity history for this application.`));
            return undefined;
        }
        if (!activityHistory.ok) {
            const errorText = await activityHistory.text();
            dispatch(showErrorMessage(errorText || `Failed to load activity history (HTTP ${activityHistory.status})`));
            return undefined;
        }
        return await activityHistory.json();
    }

    const getAndShowApiMessageHistoryDialogAsync = async () => {
        dispatch({ type: SET_LOADING, payload: true });
        const activityRecords = await getActivityHistoryForApplication(currentApp!.id);
        dispatch({ type: SET_LOADING, payload: false });

        if (activityRecords) {
            openDialog({
                children: (
                    <ApiMessageHistoryDialog
                        title={'Application Activity History'}
                        activityRecords={activityRecords}
                        employees={employees}
                        onClose={closeDialog}
                        accept={closeDialog}
                        closeDialog={closeDialog}
                    />
                ),
            });
        }
    }

    // User has closed the success snackbar.
    const handleCloseSnackbar = (event: React.SyntheticEvent<any> | Event, reason: SnackbarCloseReason) => {
        setIsSnackbarOpen(false);
    }

    // User has closed the success snackbar.
    const handleAlertClose = (event: React.SyntheticEvent<any>) => {
        setIsSnackbarOpen(false);
    };

    const sendSimpleEmailMessagesToContactOnAppOpen = (emailMessage: SimpleEmailMessage) => {
        sendSimpleEmailMessagesToContact(currentApp!, emailMessage, dispatch, closeDialog);
    }

    const sendSimpleTextMessagesToContactOnAppOpen = (textMessage: SimpleTextMessage) => {
        sendSimpleTextMessagesToContact(currentApp!, textMessage, currentEmployee, dispatch, closeDialog);
    }

    const openSimpleMessagingForPortalLinkDialog = async (linkType: LinkType) => {
        try {
            if (!currentApp) {
                return;
            }

            // set the isGeneratingCustomerPortalLink flag to true so we can show a loading indicator
            setIsGeneratingCustomerPortalLink(true);

            const response: { portalLink: string } | { error: string } = await generateCustomerPortalLink(currentApp.contactOpportunityId!, linkType, dispatch);

            // show an error if we were unable to generate a customer portal link
            if (hasValue((response as { error: string }).error)) {
                dispatch({ type: "SET_SERVER_MESSAGE", payload: { message: (response as { error: string }).error, isError: true } });
                return;
            }

            if (!hasValue((response as { portalLink: string }).portalLink)) {
                dispatch({ type: "SET_SERVER_MESSAGE", payload: { message: 'Unable to generate a customer portal link. Please try again.', isError: true } });
                return;
            }

            const portalLink = (response as { portalLink: string }).portalLink;

            // Gets both the text and email templates filled at the same time
            const [filledEmailTemplateSubjectAndBody, filledTextTemplateSubjectAndBody] = await Promise.all([
                getFilledTemplate(currentApp.contactOpportunityId!, MessageTemplates.continueApplicationEmail, dispatch),
                getFilledTemplate(currentApp.contactOpportunityId!, MessageTemplates.continueApplicationText, dispatch)
            ]);

            (filledEmailTemplateSubjectAndBody as FilledTemplateSubjectAndBody).body =
                ((filledEmailTemplateSubjectAndBody as FilledTemplateSubjectAndBody).body ?? '') + '<p>' + portalLink + '</p>';
            (filledTextTemplateSubjectAndBody as FilledTemplateSubjectAndBody).body =
                ((filledTextTemplateSubjectAndBody as FilledTemplateSubjectAndBody).body ?? '') + '\n\n' + portalLink;

            setIsGeneratingCustomerPortalLink(false);

            const recipientOptions = getCustomerPortalLinkMenuOptions(currentApp);

            openDialog({
                children: (
                    <SimpleMessagingDialog
                        dialogTitle={'Send Portal Link Message'}
                        onClose={closeDialog}
                        selectableRecipients={recipientOptions}
                        defaultEmailSubject={(filledEmailTemplateSubjectAndBody as FilledTemplateSubjectAndBody).subject}
                        defaultEmailBody={(filledEmailTemplateSubjectAndBody as FilledTemplateSubjectAndBody).body}
                        defaultTextMessage={(filledTextTemplateSubjectAndBody as FilledTemplateSubjectAndBody).body}
                        onSendEmailMessage={sendSimpleEmailMessagesToContactOnAppOpen}
                        onSendTextMessage={sendSimpleTextMessagesToContactOnAppOpen}
                    />
                ),
            });
        } catch (error) {
            dispatch({
                type: "SET_SERVER_MESSAGE",
                payload: { message: error as string, isError: true }
            });
            setIsGeneratingCustomerPortalLink(false);
        }
    };

    const showGenerateCustomerPortalLinkButton = currentApp
        && hasValue(currentApp.contactOpportunityId) && hasValue(currentApp.contactId)
        && configuration && configuration.featureFlags[FeatureFlagIds.AllowCustomerPortalLinkCreation];

    const canGenerateAddCoApplicantLink = currentApp?.appCustomers.length === 1 && embedCreditApplicationVersion === 2;

    // Whether the show the "Print Documents" button. Show if:
    // find the applicationStatusWorkflowItem that matches the currentApp.appStatusId and the nextStatusId is next status is finalized and posted.
    const applicationStatusWorkflowItems = applicationStatusWorkflows.find((asw) => asw.applicationQuoteType === currentApp?.quoteType)?.applicationStatusWorkflowItems ?? [];

    // Returns the selected application's loanClassId
    const getLoanClassId = (): string | undefined => {
        // get the loanClassId off of the applicationLeaseQuote if it's curently null/undefined
        return getSelectedFinanceQuote(currentApp)?.financeLoanClassId ?? currentApp!.applicationLeaseQuote?.leaseLoanClassId;
    }

    // Returns both the disabled state and tooltip reason for the Print Docs button
    const getPrintDocsButtonState = (): { disabled: boolean; reason: string } => {
        const { hasAlwaysPrintableDocs, hasApplicationContextDocuments } = printAvailability;

        // Loading states
        if (checkingAlwaysPrintable) {
            return { disabled: true, reason: "Checking document availability..." };
        }
        if (loadingPrintDocuments) {
            return { disabled: true, reason: "Loading documents..." };
        }

        // Employee validation (only if no always-printable docs)
        if (!hasValue(currentEmployee?.employeeNumber) && !hasAlwaysPrintableDocs) {
            return {
                disabled: true,
                reason: "There is no employee number associated with your employee record. Please contact your administrator to set this up."
            };
        }

        // DealerFlow 360 prints a refinance's or side note's documents.
        if (isReadOnlyLoanSideDeal) {
            return { disabled: true, reason: lockMessage };
        }

        // Application unlocked check
        if (isCurrentlyUnlocked) {
            return { disabled: true, reason: "Document printing is disabled while the application is unlocked." };
        }

        // Check if workflow allows printing (current status can transition to finalizedPosted)
        const workflowAllowsPrinting = applicationStatusWorkflowItems.some(aswi =>
            aswi.currentStatusId?.toLowerCase() === currentApp?.appStatusId.toLowerCase()
            && aswi.nextStatusId.toLowerCase() === Constants.applicationStatuses.finalizedPosted.toLowerCase());

        // Enabled if hasAlwaysPrintableDocs OR (hasApplicationContextDocuments AND workflowAllowsPrinting)
        const canPrintViaWorkflow = hasApplicationContextDocuments && workflowAllowsPrinting;
        const canPrint = hasAlwaysPrintableDocs || canPrintViaWorkflow;

        if (!canPrint) {
            if (!hasApplicationContextDocuments) {
                return { disabled: true, reason: "No documents are configured for application printing." };
            }
            if (!workflowAllowsPrinting) {
                return { disabled: true, reason: "Document printing is not available for this application status." };
            }
            return { disabled: true, reason: "Document printing is not available for this application." };
        }

        return { disabled: false, reason: "Print documents for this application" };
    };

    // Deliberately independent of getPrintDocsButtonState: Print History is a read-only view and must stay
    // viewable on apps that can no longer be printed. Extend here if a permission gate is ever added.
    const getPrintHistoryButtonState = (): { disabled: boolean; reason: string } => {
        return { disabled: false, reason: "View Print History" };
    };

    // Seeing if it's been posted yet
    const showCustomerNumberReservationButton = configuration?.featureFlags[FeatureFlagIds.ClientPostsLoansDirectlyToAms] === true && !hasValue(currentApp?.sentToAmsDate);

    const allAppStatusesAvailableByButton = applicationStatusWorkflowItems.filter((aswi) =>
        aswi.triggeredBy === 'Button' &&
        canAct('Actions', aswi.label!));
    const userCanSeeThePostButtonWhenAvailable = allAppStatusesAvailableByButton.some((aswi) => aswi.nextStatusId.toLowerCase() === Constants.applicationStatuses.finalizedPosted.toLowerCase());

    // For Finance quote type, both helpers use the last solved quote snapshot for their values
    // Undefined for a lease that isn't solved: the Down PMT button says so before reading it (B3).
    const downPaymentOnQuote = getDownPaymentFromQuote(currentApp, lastSolvedSelectedFinanceQuote, configuration);
    const totalDownPaymentAmountPaid = getTotalDownPaymentAmountPaid(applicationDownPaymentResponses) ?? 0;
    const applicantOwesMoreDownPayment = (downPaymentOnQuote ?? 0) > totalDownPaymentAmountPaid;

    const balanceOnQuote = getBalanceOnQuote(currentApp, lastSolvedSelectedFinanceQuote, configuration);

    // Gets the loan documents for this application.
    // Uses the entity endpoint which supports optional loanClassId for IsAlwaysPrintable docs without a loan class.
    const getDocumentsForApplication = async (): Promise<{ loanPrintData: LoanPrintDataResponse } | undefined> => {
        const loanClassId = getLoanClassId();
        const bearerToken = await authService.getToken();
        // No context param needed - LOS API always uses Application context
        const url = loanClassId
            ? `api/documentPrint/entity/${currentApp!.id}?loanClassId=${loanClassId}`
            : `api/documentPrint/entity/${currentApp!.id}`;
        const response: Response | undefined = await httpGetAsync(url, bearerToken!);

        if (isNil(response)) {
            dispatch(showErrorMessage(`Did not find any documents for this application.`));
            return undefined;
        }

        // Check for HTTP error codes (e.g. 500 Internal Server Error)
        if (!response.ok) {
            try {
                const errorData = await response.json();
                const errorMessage = errorData?.title || errorData?.message || `Server error (${response.status})`;
                dispatch(showErrorMessage(`Error loading documents: ${errorMessage}`));
            } catch {
                dispatch(showErrorMessage(`Error loading documents: Server returned status ${response.status}`));
            }
            return undefined;
        }

        return await response.json();
    }

    // Checks print availability for the Application context
    const checkPrintAvailability = async () => {
        setCheckingAlwaysPrintable(true);
        try {
            const bearerToken = await authService.getToken();
            const response = await httpGetAsync('api/documentPrint/printAvailability', bearerToken!);
            if (response) {
                const data = await response.json();
                setPrintAvailability({
                    hasAlwaysPrintableDocs: data.hasAlwaysPrintableDocs,
                    hasApplicationContextDocuments: data.hasApplicationContextDocuments,
                });
            }
        } finally {
            setCheckingAlwaysPrintable(false);
        }
    };

    const openCustomerNumberReservationDialogAsync = async (): Promise<boolean> => {
        return new Promise(resolve => {
            if (!previousAmsLoans) {
                openDialog({
                    children: (
                        <ErrorDialog
                            title="Previous AMS Loans"
                            errors={['Please try again in a few moments for the previous AMS customers query to complete']}
                            closeDialog={() => {
                                closeDialog();
                            }}
                        />
                    ),
                });
            } else {
                openDialog({
                    children: (
                        <CustomerNumberReservationDialog
                            title="Update Customer Number"
                            configuration={configuration!}
                            accept={() => {
                                closeDialog();
                                resolve(true);
                            }}
                            closeDialog={() => {
                                closeDialog();
                                resolve(false);
                            }}
                        />
                    ),
                });
            }
        });
    }

    const conditionallyOpenCustomerNumberReservationDialog = async (): Promise<boolean> => {
        return new Promise(resolve => {
            const atLeastOneApplicantNeedsAnAmsCustomerNumber = currentApp?.appCustomers.some(ac => !hasValue(ac.customer.amsCustomerNumber));
            // If one of the applicants doesn't have an AMS customer number, show the dialog to let them create one
            if (atLeastOneApplicantNeedsAnAmsCustomerNumber) {
                const result = openCustomerNumberReservationDialogAsync();
                resolve(result);
            } else {
                // On to the next check or dialog
                resolve(true);
            }
        });
    }

    // Parses a prompt answer string into the appropriate type based on DocumentInputType
    const parsePromptAnswer = (
        answer: string,
        inputType: DocumentInputType | undefined
    ): string | number | boolean | Date => {
        switch (inputType) {
            case DocumentInputType.Number:
                return parseFloat(answer);
            case DocumentInputType.TrueFalse:
                return answer.toLowerCase() === 'true';
            case DocumentInputType.YesNo:
                return answer.toLowerCase() === 'yes' ? 'yes' : 'no';
            case DocumentInputType.Date:
                return new Date(answer);
            default:
                return answer;
        }
    };

    // Builds prompt values from loan print data, applying saved answers with proper type conversion
    const buildPromptValues = (loanPrintData: LoanPrintData): PromptIdValue[] => {
        const { loanDocumentsWithPrompts, loanPrintDocumentPromptAnswers } = loanPrintData;

        // Build initial prompt values with defaults, de-duplicated by canonical prompt id so a shared
        // prompt produces a single entry. Track the prompt type for value conversion.
        const promptTypeMap = new Map<string, DocumentInputType | undefined>();
        const promptValues: PromptIdValue[] = [];
        loanDocumentsWithPrompts.forEach(ld => {
            ld.prompts.forEach(p => {
                const key = p.id.toLowerCase();
                if (!promptTypeMap.has(key)) {
                    promptTypeMap.set(key, p.inputType);
                    promptValues.push({ promptId: p.id, value: p.defaultValue || '' });
                }
            });
        });

        // Collapse saved answers to the most recent per canonical prompt id (most-recent-by-modifiedDate
        // wins), then override the initial values.
        const latestAnswerByPromptId = new Map<string, (typeof loanPrintDocumentPromptAnswers)[number]>();
        loanPrintDocumentPromptAnswers.forEach(lpdpa => {
            const key = lpdpa.loanDocumentPromptId.toLowerCase();
            const current = latestAnswerByPromptId.get(key);
            if (!current || (lpdpa.modifiedDate ?? '') >= (current.modifiedDate ?? '')) {
                latestAnswerByPromptId.set(key, lpdpa);
            }
        });
        latestAnswerByPromptId.forEach(lpdpa => {
            const promptValue = promptValues.find(
                pv => pv.promptId.toLowerCase() === lpdpa.loanDocumentPromptId.toLowerCase()
            );
            if (promptValue) {
                const promptType = promptTypeMap.get(lpdpa.loanDocumentPromptId.toLowerCase());
                (promptValue as any).value = parsePromptAnswer(lpdpa.promptAnswer, promptType);
            }
        });

        return promptValues;
    };

    // User has clicked the "Print Documents" button on the details card
    const handleLoadPrintDocumentsStepper = async () => {
        // Skip customer number reservation check if there are always-printable documents
        // (allows printing without a vehicle when only always-printable docs are available)
        if (!printAvailability.hasAlwaysPrintableDocs) {
            const continueAfterCustomerNumberCheck = await conditionallyOpenCustomerNumberReservationDialog();
            if (!continueAfterCustomerNumberCheck) return;
        }

        setLoadingPrintDocuments(true);

        try {
            const data = await getDocumentsForApplication();

            if (isNil(data)) {
                dispatch(showErrorMessage(`Did not find any documents for this application's loan class.`));
                return;
            }

            // Get the loan print data from the response
            const { loanPrintData } = data;
            const { owedToCustomerItems, loanDocumentsWithPrompts } = loanPrintData;

            const resolvedPromptValues = buildPromptValues(loanPrintData);

            // Extract eligible ApplicationDocuments for the "Existing PDFs" step
            const eligibleDocs: NamedId[] = (loanPrintData.eligibleApplicationDocuments ?? [])
                .map(doc => ({ id: doc.id.toString(), name: doc.name }));

            // Batch all state updates together
            setLoanPrintData(loanPrintData);
            setAllOwedToCustomerItems(owedToCustomerItems);
            setOwedToCustomerItems(owedToCustomerItems);
            setLoanDocuments(loanDocumentsWithPrompts);
            setPromptValues(resolvedPromptValues);
            setExistingPdfs(eligibleDocs);
            setSelectedExistingPdfIds([]);
            setShowPrintDocuments(true);
        } finally {
            setLoadingPrintDocuments(false);
        }
    }

    // The selected documents as loan-print rows, carrying the saved row id for any document that was on the
    // previous print. A print carries no order (order is admin-controlled).
    const buildCreateUpdateLoanPrintDocuments = (): CreateUpdateLoanPrintDocument[] =>
        loanDocuments
            .filter(ld => selectedLoanDocumentIds.includes(ld.id))
            .map(ld => ({
                id: loanPrintData.loanPrintDocuments.find(lpd => lpd.loanDocumentId === ld.id)?.id ?? null,
                loanDocumentId: ld.id,
            }));

    // Async function to save which documents are on the print and the prompt answers.
    const saveLoanPrintChanges = async (loanPrintDocuments: CreateUpdateLoanPrintDocument[], promptAnswers: CreateUpdateLoanPrintDocumentPromptAnswer[]) => {
        // get token
        const bearerToken = await authService.getToken();
        // Loan print object
        const updateLoanPrint: UpdateLoanPrint = {
            loanPrintId: hasValue(loanPrintData.loanPrint?.id) ? loanPrintData.loanPrint.id : null,
            entityId: currentApp!.id,
            printContext: PrintContext.Application,
            documents: loanPrintDocuments,
            promptAnswers: promptAnswers
        };
        const documentPdfs: Response | undefined = await httpPostAsync(
            `api/documentPrint/loanPrint`,
            updateLoanPrint,
            bearerToken!
        );
        if (isNil(documentPdfs)) {
            setLoadingPrintPreview(false);
            dispatch(showErrorMessage(`Error generating print preview.`));
            return;
        }
        return;
    }

    // itemNumber is 1-based in the database and must be contiguous — backend template placeholders read
    // WhatWeOwe{n}* and skip missing indices, so re-sequence after any mid-session deletions.
    const shapeOwedToCustomerItemsForApi = (items: OwedToCustomerItem[]) =>
        items.map((owc, index) => ({
            itemName: owc.itemName,
            itemNumber: index + 1,
            itemQuantity: owc.itemQuantity,
            itemCost: owc.itemCost,
            itemLaborCost: owc.itemLaborCost,
            comments: owc.comments,
        }));

    const saveOwedToCustomerItems = async () => {
        const bearerToken = await authService.getToken();
        const response: Response | undefined = await httpPostAsync(
            `api/documentPrint/owedToCustomer`,
            {
                applicationId: currentApp!.id,
                items: shapeOwedToCustomerItemsForApi(owedToCustomerItems),
            },
            bearerToken!);
        if (isNil(response)) {
            dispatch(showErrorMessage(`Error saving "what we owe" items.`));
            return;
        }
        return;
    }

    // User has clicked the "Print Preview" button on the DocumentPrintStepper. We need to:
    // 1. Get all the docs from S3
    // 2. Replace variables in the docs with the values (including prompt values)
    // 3. Combine the docs into one PDF
    // 4. Show the combined PDF
    // Generates AND persists the combined PDF in a single call. Backend POST /printDocuments now performs the
    // historical-union + supersede + LoanPrint snapshot atomically and returns { documents } so we can render the
    // preview from the same response. Replaces the old preview-only getDocumentBytes call (which never persisted,
    // so the Documents tab and Print History stayed empty unless the user clicked the in-viewer printer icon).
    const generateAndPersistCombinedPdfAsync = async () => {
        const bearerToken = await authService.getToken();
        // No order is sent: the server resolves print order itself and ignores any client value.
        const selectedDocs = loanDocuments.filter(ld => selectedLoanDocumentIds.includes(ld.id)).map(ld => ({ id: ld.id, name: ld.name }));
        const postBody = {
            entityId: currentApp!.id,
            loanClassId: getLoanClassId(),
            loanDocuments: selectedDocs,
            promptIdValues: promptValues,
            owedToCustomerItems: shapeOwedToCustomerItemsForApi(owedToCustomerItems),
            applicationDocumentIds: selectedExistingPdfIds.map(id => parseInt(id)),
        };
        const response: Response | undefined = await httpPostAsync(`api/documentPrint/printDocuments`, postBody, bearerToken!);
        if (isNil(response)) {
            return null;
        }
        if (!response.ok || response.status !== 200) {
            const error = await response.json();
            return { error: `${error.title}: ${error.detail}` };
        }
        return await response.json();
    }

    // Single atomic POST: backend persists the combined PDF + owed items, then returns the bytes. On error the
    // stepper does not advance (R1a) — the prior combined PDF keeps its visibility via backend rollback.
    const handlePrintPreview = async () => {
        setLoadingPrintPreview(true);
        const data = await generateAndPersistCombinedPdfAsync();
        if (!isNil(data?.error)) {
            setLoadingPrintPreview(false);
            dispatch(showErrorMessage(`Error generating print preview. ${data.error}`));
            return;
        }
        if (hasValue((data as { error: string }).error)) {
            setLoadingPrintPreview(false);
            dispatch(showErrorMessage((data as { error: string }).error));
            return;
        }
        const combinedBase64 = (data as any).documents;
        // Backend ships previewDocuments alongside documents from /printDocuments. Fall back to the combined bytes when
        // it's missing (deploy-skew window before backend ships, or any non-Application caller that doesn't add the field).
        const previewBase64 = (data as any).previewDocuments ?? combinedBase64;
        setCombinedPrintPdf(combinedBase64);
        setPrintPreviewPdf(previewBase64);
        setLoadingPrintPreview(false);
        setAllOwedToCustomerItems(owedToCustomerItems);
        setStepperIndex(steps.REVIEW_PRINT);
    }

    useEffect(() => {
        if (showGenerateCustomerPortalLinkButton && shouldOpenGeneratePortalLinkDialog) {
            openSimpleMessagingForPortalLinkDialog(LinkType.applicationLink);
            dispatch(setShouldOpenGeneratePortalLinkDialog(false));
        }
    }, [currentApp, configuration, shouldOpenGeneratePortalLinkDialog]);

    // Check print availability when the application changes
    useEffect(() => {
        if (currentApp) {
            checkPrintAvailability();
        }
    }, [currentApp?.id]);

    const updateReDeskDealToAms = async () => {
        // Re-desking moves the deposits too, so a card down payment AMS doesn't have yet stops it (A12); the server refuses
        // it as well, so a failed read lets it through to the server's answer.
        let cardRefusal: string | undefined;
        try {
            cardRefusal = unfinishedCardPostingRefusal(await fetchDownPaymentCardChargesNow(currentApp!.id));
        } catch (err) {
            console.error('Error reading card down payments:', err);
        }
        if (cardRefusal) {
            openDialog({
                children: (
                    <ErrorDialog
                        title="Card Down Payment"
                        errors={[cardRefusal]}
                        closeDialog={() => {
                            closeDialog();
                        }}
                    />
                ),
            });
            return;
        }

        const updatedApp = produce(currentApp!, appToUpdate => {
            appToUpdate.reDeskDealToAms = true;
        })
        dispatch(updateEditingApp(updatedApp, businessRulesEngine));

        props.handleSaveAppFromOverview(updatedApp, currentApp!.appStatusId, false);
    }

    const canReDesk = canAct("Actions", "Contracted") || canAct("Actions", "Desk");
    const applicationStatusIsReDeskAble = currentApp
        ? applicationCanBeReDeskedInStatus(currentApp.appStatusId, configuration)
        : false;

    const disableReDeskButton = isCurrentlyUnlocked || isReadOnlyLoanSideDeal;
    // Getting the list of stores AND also the name of the location that the deal is assigned to so that something shows
    // Users without AccessApplicationsAcrossLocations only see their own org + the app's current org
    const canAccessAcrossLocations = userHasPermission(activeUser, permissions.accessApplicationsAcrossLocations, PermissionSet.R);
    const stores = allOrganizations.filter(o => o.typeId === Constants.organizationTypes.storeId || o.id === currentApp?.organizationId)
        .filter(o => canAccessAcrossLocations ? true : o.id === activeUser.organizationId || o.id === currentApp?.organizationId)
        // Only offer locations that can quote this kind of deal; the assigned location always stays so the dropdown can display it
        .filter(o => o.id === currentApp?.organizationId || organizationAllowsQuoteType(o, currentApp?.quoteType));


    // Resets all info related to the print preview stepper.
    const resetPrintPreviewStepperInfo = () => {
        setLoanDocuments([]);
        setSelectedLoanDocumentIds([]);
        setPromptValues([]);
        setOwedToCustomerItems([]);
        setExistingPdfs([]);
        setSelectedExistingPdfIds([]);
        setStepperIndex(0);
        setWindowStage('FULLSCREEN');
        setLoadingPrintPreview(false);
        setIsPrintingLoanDocuments(false);
        setPrintPreviewPdf('');
        setCombinedPrintPdf('');
    }

    // User has clicked Close/Cancel on the DocumentPrintStepper
    const handlePrintPreviewClose = () => {
        // If there are no documents loaded, none selected, or we're on the confirmation step (printing is done), just close.
        if (loanDocuments.length === 0 || selectedLoanDocumentIds.length === 0 || stepperIndex === steps.CONFIRMATION) {
            closeDialog();
            // reset all the values when the window is closed
            resetPrintPreviewStepperInfo();
            setShowPrintDocuments(false);
            return;
        }
        // when cancelling, prompt user and ask if they want to save changes
        openDialog({
            fullScreen: false,
            children: (
                <ConfirmationDialog
                    title="Save Changes"
                    prompt={`Do you want to save the answers you've made to any prompts?`}
                    accept={() => {
                        // Fan one display value per canonical prompt out to every selected document that
                        // uses it (a shared prompt writes one answer per associated document).
                        const selectedDocumentsWithPrompts = loanPrintData.loanDocumentsWithPrompts
                            .filter(ld => selectedLoanDocumentIds.includes(ld.id));
                        const createUpdateLoanPrintDocumentPromptAnswers = expandPromptValuesToAnswers(
                            selectedDocumentsWithPrompts,
                            promptValues,
                            loanPrintData.loanPrintDocumentPromptAnswers
                        );
                        // save prompt answers. no need to save loanPrintDocuments because the selection has not changed at this point.
                        saveLoanPrintChanges([], createUpdateLoanPrintDocumentPromptAnswers);
                        // save "What We Owe" items if at least one item has been added/edited.
                        if (owedToCustomerItems.length > 0) {
                            saveOwedToCustomerItems();
                        }
                        closeDialog();
                        // reset all the values when the window is closed
                        resetPrintPreviewStepperInfo();
                        setShowPrintDocuments(false);
                    }}
                    closeDialog={() => {
                        closeDialog();
                        // reset all the values when the window is closed
                        resetPrintPreviewStepperInfo();
                        setShowPrintDocuments(false);
                    }}
                />
            )
        });
    }

    // Async method for Printing the loan documents
    // Uses the window.print default method to print the printPreviewPdf byte array
    const printDocumentsInBrowser = () => {
        if (hasValue(printPreviewPdf)) {
            // Create a blob from the printPreviewPdf
            const blob = new Blob([Uint8Array.from(atob(printPreviewPdf), c => c.charCodeAt(0))], { type: 'application/pdf' });
            const url = URL.createObjectURL(blob);
            // Open a new window and print the PDF.
            const printWindow = window.open(url, '_blank', 'width=800,height=600');
            if (printWindow) {
                printWindow.onload = () => {
                    printWindow.print();
                    printWindow.onafterprint = () => {
                        printWindow.close();
                    };
                };
            }
        } else {
            dispatch(showErrorMessage('No PDF to print.'));
        }
    }

    // The combined PDF was already persisted when the user clicked Print Preview, so this handler is now no-persist
    // (R1c). It opens the OS print dialog with the bytes already returned from that earlier call, advances the stepper
    // to Confirmation, and stamps a local printTime so the UI reflects the action — no additional backend call.
    const handlePrintDocumentsAsync = async () => {
        setIsPrintingLoanDocuments(true);
        try {
            setStepperIndex(steps.CONFIRMATION);
            setLoanPrintData({
                ...loanPrintData,
                loanPrint: {
                    ...loanPrintData.loanPrint,
                    printTime: new Date()
                },
                loanDocumentsWithPrompts: loanDocuments.map(ld => {
                    if (selectedLoanDocumentIds.includes(ld.id)) {
                        return {
                            ...ld,
                            lastPrinted: new Date().toISOString()
                        }
                    } else {
                        return ld;
                    }
                })
            });
            printDocumentsInBrowser();
        } catch (error) {
            dispatch(showErrorMessage(`Error printing documents: ${error}`));
        } finally {
            setIsPrintingLoanDocuments(false);
        }
    }

    // Both the bottom "Download Docs" button and the toolbar Kendo download icon download the selected-only
    // preview bytes — what the user sees in the previewer. The persisted combined package (loan docs +
    // historical-union + Existing PDFs) stays server-side for downstream consumers.
    const downloadPrintPreviewPdf = () => {
        if (hasValue(printPreviewPdf)) {
            const blob = new Blob([Uint8Array.from(atob(printPreviewPdf), c => c.charCodeAt(0))], { type: 'application/pdf' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = `Application_${currentApp?.applicationNo ?? ''}_LoanDocuments.pdf`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } else {
            dispatch(showErrorMessage('No PDF to download.'));
        }
    }

    return (
        <div style={{ flexGrow: 1 }}>
            <Card>
                <CardHeader
                    avatar={<InfoIcon fontSize="small" />}
                    title="Application Details"
                    action={<div>
                        {isSuperUser &&
                            <Tooltip title={"API Message History"}>
                                <IconButton
                                    onClick={getAndShowApiMessageHistoryDialogAsync}
                                    style={{ color: unlockButtonColor }}
                                >
                                    <HistoryIcon />
                                </IconButton>
                            </Tooltip>
                        }
                        {canUnlockApp &&
                            <Tooltip title={
                                isCurrentlyUnlocked
                                    ? (activeUnlock ? `Unlocked: ${activeUnlock.unlockedSections.join(', ')} — Click to re-lock` : 'App is unlocked')
                                    : 'Unlock Application'
                            }>
                                <IconButton
                                    onClick={toggleAppLock}
                                    style={{ color: unlockButtonColor }}
                                >
                                    {isCurrentlyUnlocked ? <LockOpenIcon /> : <LockIcon />}
                                </IconButton>
                            </Tooltip>
                        }
                        {currentApp && showUnlockDialog &&
                            <UnlockDialog
                                applicationId={currentApp.id}
                                visible={showUnlockDialog}
                                onClose={() => setShowUnlockDialog(false)}
                                onUnlock={handleUnlockSubmit}
                            />
                        }
                        {showDownloadAppButton && (
                            <Tooltip title={applicationDownloadMode === 'report' ? "Download Application Report" : "Download Application PDF"}>
                                <IconButton
                                    onClick={() => applicationDownloadMode === 'report' ? getApplicationReport() : pdfApp()}
                                    style={{ color: '#757575' }}
                                >
                                    <GetAppIcon />
                                </IconButton>
                            </Tooltip>
                        )}
                    </div>}
                />
                <Divider variant="middle" />
                <CardContent>
                    {currentApp &&
                        <NotesDialog
                            notes={currentApp.applicationNotes}
                            employee={activeUser}
                            canAddNote={true}
                            open={showNotesDialog}
                            onSave={handleAddNotes}
                            onClose={() =>
                                setShowNotesDialog(false)
                            }
                        />
                    }

                    {currentApp ?
                        <Grid container spacing={1}>
                            <Grid item xs={12} sm={6}>
                                Application #: {addThousandsSeparator(currentApp.applicationNo)}
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                App Date: {currentApp.applicationDate.toLocaleDateString()}
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <InputLabel id="select-label">Application Status:</InputLabel>
                                <Tooltip title={lockedTooltip('Status')} placement="top">
                                    <span>
                                        <Select fullWidth
                                            name='appStatusSelect'
                                            labelId="select-label"
                                            inputProps={{ readOnly: isPostedAndLocked ? isSectionLocked('Status') : !currentApp?.unlockedBySuperUser }}
                                            id="select"
                                            variant='standard'
                                            value={currentApp.appStatusId}
                                            onChange={(e: any) => updateAppStatus(e.target.value)}
                                            sx={{
                                                color: appStatuses.find(s => s.id.toUpperCase() === currentApp.appStatusId.toUpperCase())?.textColor ?? 'black',
                                                backgroundColor: appStatuses.find(s => s.id.toUpperCase() === currentApp.appStatusId.toUpperCase())?.backgroundColor ?? 'white', borderRadius: '4px',
                                                padding: '0 3px'
                                            }}
                                        >
                                            {appStatuses.map((x, key) => (
                                                <MenuItem key={key} value={x.id}>{x.name}</MenuItem>
                                            ))}
                                        </Select>
                                    </span>
                                </Tooltip>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <InputLabel id="select-location-label">Location:</InputLabel>
                                <Select
                                    fullWidth
                                    name='locationSelect'
                                    labelId="select-location-label"
                                    id="select"
                                    variant='standard'
                                    value={stores.find(s => s.id === currentApp.organizationId) ? currentApp.organizationId : ''}
                                    onChange={(e: any) => updateLocation(e.target.value)}
                                    disabled={isReadOnlyLoanSideDeal || ((currentApp.quoteType === ApplicationQuoteType.Indirect) &&
                                        (currentApp.appSource === 'RouteOne' || currentApp.appSource === 'DealerTrack'))}
                                >
                                    {stores
                                        .filter(store => {
                                            const currentStore = stores.find(s => s.id === currentApp.organizationId);
                                            return currentStore?.isOwnedByClient == true
                                                ? store.isOwnedByClient
                                                : true;
                                        })
                                        .map((x, key) => (
                                            <MenuItem key={key} value={x.id}>
                                                {configuration?.featureFlags?.[FeatureFlagIds.DisplayLocationDescription] !== true
                                                    ? x.name
                                                    : x.description}
                                            </MenuItem>
                                        ))
                                    }
                                </Select>
                            </Grid>

                            {/*dynamically builds and fills the roles that can be assigned to an application*/}
                            {isSectionLocked('Assignments') &&
                                <Grid item xs={12}>
                                    <LockNotice message={lockMessage} />
                                </Grid>
                            }
                            {applicationAssignableRoles.map((aar, key) => {
                                const assignableRoleControls: JSX.Element[] = [];
                                const roleAssignableByUser = canAssignRole(aar.employeeRoleId);

                                for (let i = 0; i < aar.numberAllowed; i++) {

                                    const roleLabel = (aar.numberAllowed > 1 ? getOrdinalNumber(i + 1) : '') + employeeRoles.find(er => er.id === aar.employeeRoleId)?.name;
                                    if (configuration?.featureFlags?.[FeatureFlagIds.HideUnderwriter] === true && isSalesPerson(activeUser) && roleLabel === 'Underwriter')
                                        return;

                                    assignableRoleControls.push(
                                        <AssignableEmployeeSelect
                                            key={i}
                                            roleLabel={(aar.numberAllowed > 1 ? getOrdinalNumber(i + 1) : '') + employeeRoles.find(er => er.id === aar.employeeRoleId)?.name}
                                            selectedEmployeeId={assignedEmployeeIdForSlot(aar.employeeRoleId, i + 1)}
                                            selectableEmployees={getValidEmployeesByRole(currentApp.applicationAssignments.find(aa => aa.assignmentEmployeeRoleId === aar.employeeRoleId && aa.assignmentRoleSequence === i + 1)?.assignedToId ?? '', aar.employeeRoleId)}
                                            applicationAssignableRole={aar}
                                            sequence={i + 1}
                                            assignable={roleAssignableByUser && !isSectionLocked('Assignments')}
                                            onChange={(roleId: string, sequence: number, value: string) => {
                                                if (currentApp) {
                                                    const app = produce(currentApp, (currentApp) => {
                                                        if (currentApp.applicationAssignments.find(aa => aa.assignmentEmployeeRoleId === roleId && aa.assignmentRoleSequence === sequence) === undefined) {
                                                            currentApp.applicationAssignments.push({ //adds new record to the array
                                                                id: v4(),
                                                                applicationId: currentApp.id,
                                                                assignedToId: value,
                                                                assignmentEmployeeRoleId: roleId,
                                                                assignmentRoleSequence: sequence
                                                            });
                                                        }
                                                        currentApp.applicationAssignments.find(aa => aa.assignmentEmployeeRoleId === roleId && aa.assignmentRoleSequence === sequence)!.assignedToId = value;

                                                        if (currentApp.appStatusId === Constants.applicationStatuses.new) {
                                                            currentApp.appStatusId = Constants.applicationStatuses.sales;
                                                        }
                                                    });

                                                    dispatch(updateEditingApp(app, businessRulesEngine));
                                                }
                                            }}
                                        />)
                                }
                                return (assignableRoleControls);
                            })}

                            <Grid item xs={12} sm={6}></Grid>

                            <Grid item xs={12}>
                                <Divider variant="fullWidth" />
                            </Grid>

                            {unfinishedCardBar &&
                                // A12: a card down payment AMS doesn't have yet blocks other down payments and posting.
                                <Grid item xs={12}>
                                    <Notification type={{ style: 'warning', icon: true }} style={{ width: '100%' }}>
                                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12 }}>
                                            <span>{unfinishedCardBar}</span>
                                            <KendoButton size="small" onClick={() => setShowCardPayments(true)}>
                                                Card payments
                                            </KendoButton>
                                        </div>
                                    </Notification>
                                </Grid>
                            }

                            <Grid item xs={12} container spacing={2}>
                                {!isReadOnlyLoanSideDeal && isMergeable && !hasCobuyer(currentApp) && canAct("Actions", "Merge") && currentApp.appStatus.editable
                                    ?
                                    <Grid item>
                                        <Tooltip title="Merge Applications">
                                            <Button
                                                variant='contained'
                                                startIcon={<MergeTypeIcon />}
                                                onClick={(e) => handleMerge()}
                                                color="inherit"
                                                disabled={isCurrentlyUnlocked}
                                            >
                                                Merge
                                            </Button>
                                        </Tooltip>
                                    </Grid>
                                    :
                                    null
                                }
                                {!isReadOnlyLoanSideDeal && isMergeable && hasCobuyer(currentApp) && canUpdateApp(currentApp, activeUser) && canAct("Actions", "Merge")
                                    ?
                                    <Grid item>
                                        <Tooltip title="Unmerge Applications">
                                            <Button
                                                variant='contained'
                                                startIcon={<CallSplitIcon />}
                                                onClick={(e) => handleUnmerge()}
                                                color="inherit"
                                                disabled={isCurrentlyUnlocked}
                                            >
                                                Unmerge
                                            </Button>
                                        </Tooltip>
                                    </Grid>
                                    :
                                    null
                                }
                                {!isReadOnlyLoanSideDeal && configuration?.featureFlags[FeatureFlagIds.CopyApplication] && activeUser && userHasPermission(activeUser, permissions.copyApplication, PermissionSet.U)
                                    ?
                                    <Grid item>
                                        <Tooltip title="Copy Application">
                                            <Button
                                                variant='contained'
                                                startIcon={<ContentCopyIcon />}
                                                onClick={(e) => handleCopy()}
                                                color="inherit"
                                                disabled={isCurrentlyUnlocked}
                                            >
                                                Copy
                                            </Button>
                                        </Tooltip>
                                    </Grid>
                                    :
                                    null
                                }
                                <Grid item>
                                    <Tooltip title="Notes">
                                        <Button
                                            variant='contained'
                                            startIcon={<CommentIcon />}
                                            onClick={(e) => setShowNotesDialog(true)}
                                            color={currentApp.applicationNotes.length > 0 ? "error" : "inherit"}
                                        >
                                            Notes
                                        </Button>
                                    </Tooltip>
                                </Grid>
                                {/* {configuration?.featureFlags?.[FeatureFlagIds.CanRaiseExceptions] === true && (
                  <Grid item>
                    <Tooltip title="Raise Exception">
                      <IconButton
                        onClick={(event) => {
                          openDialog({
                            fullScreen: false,
                            children: (
                              <ApplicationExceptionDialog
                                closeDialog={closeDialog}
                                applicationExceptions={currentApp.applicationExceptions}
                                accept={(applicationExceptions: IApplicationException[]) => closeDialog}
                                readOnly={true}
                              />
                            )
                          });
                        }}
                        color={currentApp.applicationExceptions.filter(ae =>
                          ae.applicationExceptionStatusId === Constants.applicationExceptionStatuses.raisedId).length > 0
                          ? "error"
                          : "inherit"}
                      >
                        <ReportIcon />
                      </IconButton>
                    </Tooltip>
                  </Grid>
                )}
                {configuration?.featureFlags?.[FeatureFlagIds.ApplicationRehashes] === true && applicationRehashes.length > 0 &&
                  <Grid item>
                    <Tooltip title="Rehashes">
                      <IconButton
                        onClick={async (event) => {
                          await dispatch(getApplicationRehashes(currentApp.id));
                          openDialog({
                            fullScreen: false,
                            children: (
                              <ApplicationRehashDialog
                                //applicationRehashes={applicationRehashes}
                                applicationId={currentApp.id}
                                closeDialog={closeDialog}
                                accept={closeDialog}
                              />
                            )
                          });
                        }}
                        // If there are any that haven't been acknowledged
                        color={applicationRehashes.filter(ar => !ar.acknowledgedDate).length > 0
                          ? "error"
                          : "inherit"}
                      >
                        <TagIcon />
                      </IconButton>
                    </Tooltip>
                  </Grid>
                } */}

                                {showGenerateCustomerPortalLinkButton && (
                                    <>
                                        <Grid item>
                                            <Tooltip title="Generate Customer Portal Link">
                                                <Button
                                                    startIcon={<LinkIcon />}
                                                    variant='contained'
                                                    color='inherit'
                                                    disabled={isGeneratingCustomerPortalLink || getCustomerPortalLinkMenuOptions(currentApp).length === 0}
                                                    onClick={async () => openSimpleMessagingForPortalLinkDialog(LinkType.applicationLink)}
                                                >
                                                    Portal
                                                </Button>
                                            </Tooltip>
                                        </Grid>
                                        {canGenerateAddCoApplicantLink && (
                                            <Grid item>
                                                <Button
                                                    startIcon={<LinkIcon />}
                                                    variant='contained'
                                                    color='inherit'
                                                    disabled={isGeneratingCustomerPortalLink || getCustomerPortalLinkMenuOptions(currentApp).length === 0}
                                                    onClick={async () => openSimpleMessagingForPortalLinkDialog(LinkType.addCoApplicantApplicationLink)}
                                                >
                                                    Co-Applicant Link
                                                </Button>
                                            </Grid>
                                        )}
                                    </>
                                )}
                                {currentApp && applicationIsPastDesking(currentApp.appStatusId) &&
                                    <Grid item>
                                        <Tooltip title="Re-desk to AMS">
                                            <Button
                                                variant='contained'
                                                startIcon={<RedoIcon />}
                                                disabled={disableReDeskButton || !canReDesk || !applicationStatusIsReDeskAble}
                                                color="inherit"
                                                onClick={() => updateReDeskDealToAms()}
                                            >
                                                Re-Desk
                                            </Button>
                                        </Tooltip>
                                    </Grid>
                                }
                                <Grid item>
                                    <Tooltip title={getPrintDocsButtonState().reason}>
                                        <span> {/* Wrapper needed for disabled button tooltip */}
                                            <Button
                                                variant='contained'
                                                startIcon={<PrintIcon />}
                                                onClick={() => handleLoadPrintDocumentsStepper()}
                                                color="inherit"
                                                disabled={getPrintDocsButtonState().disabled}
                                            >
                                                {loadingPrintDocuments || checkingAlwaysPrintable
                                                    ? 'Loading...'
                                                    : 'Print Docs'}
                                                {(loadingPrintDocuments || checkingAlwaysPrintable) &&
                                                    <CircularProgress size={20} style={{ marginLeft: '5px' }} />}
                                            </Button>
                                        </span>
                                    </Tooltip>
                                </Grid>
                                <Grid item>
                                    <Tooltip title={getPrintHistoryButtonState().reason}>
                                        <span>
                                            <Button
                                                variant='contained'
                                                startIcon={<HistoryIcon />}
                                                onClick={() => setShowPrintHistoryDialog(true)}
                                                color="inherit"
                                                disabled={getPrintHistoryButtonState().disabled}
                                            >
                                                Print History
                                            </Button>
                                        </span>
                                    </Tooltip>
                                </Grid>
                                {configuration?.featureFlags?.[FeatureFlagIds.ZohoSignEnabled] === true && (
                                    <Grid item>
                                        <Tooltip title="View E-Sign History">
                                            <Button
                                                variant='contained'
                                                startIcon={<HistoryIcon />}
                                                onClick={() => setShowESignHistoryDialog(true)}
                                                color="inherit"
                                            >
                                                E-Sign History
                                            </Button>
                                        </Tooltip>
                                    </Grid>
                                )}
                                {configuration?.featureFlags?.[FeatureFlagIds.SecureCloseEnabled] === true && configuration?.featureFlags?.[FeatureFlagIds.ZohoSignEnabled] !== true && (
                                    <Grid item>
                                        <Tooltip title="View E-Sign History">
                                            <Button
                                                variant='contained'
                                                startIcon={<HistoryIcon />}
                                                onClick={() => setShowESignHistoryDialog(true)}
                                                color="inherit"
                                            >
                                                E-Sign History
                                            </Button>
                                        </Tooltip>
                                    </Grid>
                                )}

                                {showCustomerNumberReservationButton &&
                                    <Grid item>
                                        <Tooltip title="Add or Update Customer Number(s)">
                                            <Button
                                                variant='contained'
                                                startIcon={<TagIcon />}
                                                onClick={async () => await openCustomerNumberReservationDialogAsync()}
                                                color="inherit"
                                            >
                                                Cust Number
                                            </Button>
                                        </Tooltip>
                                    </Grid>
                                }
                                {configuration?.featureFlags[FeatureFlagIds.TakeDownPayments] && (currentApp.quoteType !== ApplicationQuoteType.Indirect)
                                    && userCanSeeThePostButtonWhenAvailable && lookups?.paymentSources.length > 0 &&
                                    <Grid item>
                                        <Tooltip title="Make a down payment">
                                            <Button
                                                variant='contained'
                                                startIcon={<AttachMoneyIcon />}
                                                onClick={() => openDownPaymentDialog()}
                                                color="inherit"
                                            >
                                                Down PMT
                                            </Button>
                                        </Tooltip>
                                    </Grid>
                                }
                            </Grid>
                        </Grid> : <LoadingPanel label="Loading..." />}
                    <Snackbar open={isSnackbarOpen} autoHideDuration={5000} onClose={handleCloseSnackbar}>
                        <Alert onClose={handleAlertClose} severity="success">
                            Application successfully unmerged
                        </Alert>
                    </Snackbar>
                </CardContent>
            </Card>
            {showPrintDocuments && (
                <Window
                    title="Print Documents"
                    onClose={handlePrintPreviewClose}
                    stage={windowStage}
                    onStageChange={(stage: WindowActionsEvent) => setWindowStage(stage.state)}
                    style={{ zIndex: 1290 }}
                >
                    <DocumentPrintStepper
                        stepperIndex={stepperIndex}
                        onChangeStepperIndex={(index: number) => setStepperIndex(index)}
                        selectedDocumentIds={selectedLoanDocumentIds}
                        onSetSelectedDocumentIds={(documentIds: string[]) => setSelectedLoanDocumentIds(documentIds)}
                        promptValues={promptValues}
                        onSetPromptValues={(values: PromptIdValue[]) => setPromptValues(values)}
                        printPreviewPdf={printPreviewPdf}
                        loanPrintData={loanPrintData}
                        isPrintingDocuments={isPrintingLoanDocuments}
                        allOwedToCustomerItems={allOwedToCustomerItems}
                        owedToCustomerItems={owedToCustomerItems}
                        onUpdateOwedToCustomerItems={(whatWeOweItems: IWhatWeOweItem[]) => {
                            setOwedToCustomerItems(whatWeOweItems.map((ww: IWhatWeOweItem) => {
                                return {
                                    applicationId: currentApp!.id,
                                    itemName: ww.name,
                                    itemNumber: ww.itemNumber,
                                    itemQuantity: ww.quantity ?? undefined,
                                    itemCost: ww.partCost ?? undefined,
                                    itemLaborCost: ww.laborCost ?? undefined,
                                    comments: ''
                                }
                            }));
                        }}
                        existingPdfs={existingPdfs}
                        selectedExistingPdfIds={selectedExistingPdfIds}
                        onSetSelectedExistingPdfIds={(ids) => setSelectedExistingPdfIds(ids)}
                        onResetOwedToCustomerItems={() => setOwedToCustomerItems(allOwedToCustomerItems)}
                        onPrintDocuments={async () => {
                            await handlePrintDocumentsAsync();
                        }}
                        onBackToPrintPreview={() => {
                            setIsPrintingLoanDocuments(false);
                            setStepperIndex(stepIndex => stepIndex - 1);
                        }}
                        onNewPrintJob={() => {
                            resetPrintPreviewStepperInfo();
                        }}
                        onClose={() => handlePrintPreviewClose()}
                    />
                    <WindowActionsBar>
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '5px' }}>
                            <KendoButton
                                themeColor={'error'}
                                fillMode={'outline'}
                                onClick={() => handlePrintPreviewClose()}
                            >
                                Close
                            </KendoButton>
                            {stepperIndex > 0 && (
                                <KendoButton
                                    themeColor={'primary'}
                                    fillMode={stepperIndex === 0 ? 'solid' : 'outline'}
                                    disabled={stepperIndex === 0}
                                    onClick={() => setStepperIndex(stepIndex => stepIndex - 1)}
                                >
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                        <SvgIcon icon={caretAltLeftIcon} />
                                        {'Back'}
                                    </div>
                                </KendoButton>
                            )}
                            {stepperIndex < steps.WHAT_WE_OWE && (
                                <KendoButton
                                    themeColor={'primary'}
                                    fillMode={stepperIndex === steps.CHOOSE_DOCS ? 'solid' : 'outline'}
                                    onClick={() => {
                                        // save loan print changes if user clicks "Next" on the first step
                                        if (stepperIndex === steps.CHOOSE_DOCS) {
                                            saveLoanPrintChanges(buildCreateUpdateLoanPrintDocuments(), []);
                                        } else if (stepperIndex === steps.ANSWER_PROMPTS) {
                                            const createUpdateLoanPrintDocuments = buildCreateUpdateLoanPrintDocuments();
                                            // Fan one display value per canonical prompt out to every selected
                                            // document that uses it (shared prompt writes one answer per document).
                                            const selectedDocumentsWithPrompts = loanPrintData.loanDocumentsWithPrompts
                                                .filter(ld => selectedLoanDocumentIds.includes(ld.id));
                                            const createUpdateLoanPrintDocumentPromptAnswers = expandPromptValuesToAnswers(
                                                selectedDocumentsWithPrompts,
                                                promptValues,
                                                loanPrintData.loanPrintDocumentPromptAnswers
                                            );
                                            // save prompt answers.
                                            saveLoanPrintChanges(createUpdateLoanPrintDocuments, createUpdateLoanPrintDocumentPromptAnswers);
                                        }
                                        // If we are on step 0, and there are no prompts to show for the selected documents, skip the prompt step.
                                        if (stepperIndex === steps.CHOOSE_DOCS) {
                                            const selectedDocuments = loanPrintData.loanDocumentsWithPrompts.filter((document) => selectedLoanDocumentIds.includes(document.id));
                                            const selectedDocumentsWithPrompts = selectedDocuments.filter((document) => document.prompts.length > 0);
                                            if (selectedDocumentsWithPrompts.length === 0) {
                                                // Skip prompts step; go to Existing PDFs if available, otherwise What We Owe
                                                setStepperIndex(steps.EXISTING_PDFS !== -1 ? steps.EXISTING_PDFS : steps.WHAT_WE_OWE);
                                            } else {
                                                setStepperIndex(stepIndex => stepIndex + 1);
                                            }
                                        } else {
                                            setStepperIndex(stepIndex => stepIndex + 1);
                                        }
                                    }}
                                    disabled={stepperIndex === steps.CHOOSE_DOCS && selectedLoanDocumentIds.length === 0 && existingPdfs.length === 0}
                                >
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                        {'Next'}
                                        {<SvgIcon icon={caretAltRightIcon} />}
                                    </div>
                                </KendoButton>
                            )}
                            {stepperIndex === steps.WHAT_WE_OWE && (
                                <KendoButton
                                    themeColor={'primary'}
                                    onClick={() => handlePrintPreview()}
                                    disabled={loadingPrintPreview
                                        || owedToCustomerItems.some(ow => !hasValue(ow.itemName) || isNil(ow.itemNumber))
                                        || (selectedLoanDocumentIds.length === 0 && selectedExistingPdfIds.length === 0)}
                                >
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                        {loadingPrintPreview ? 'Loading...' : 'Print Preview'}
                                        {!loadingPrintPreview && <SvgIcon icon={printIcon} />}
                                        {loadingPrintPreview && <CircularProgress size={20} style={{ marginLeft: '5px' }} />}
                                    </div>
                                </KendoButton>
                            )}
                            {stepperIndex === steps.REVIEW_PRINT && (
                                <>
                                    {hasValue(printPreviewPdf) && (
                                        <KendoButton
                                            themeColor={'base'}
                                            onClick={() => {
                                                downloadPrintPreviewPdf();
                                            }}
                                        >
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                Download Docs
                                                <SvgIcon icon={downloadIcon} />
                                            </div>
                                        </KendoButton>
                                    )}
                                    {hasValue(combinedPrintPdf) && configuration?.featureFlags?.[FeatureFlagIds.ZohoSignEnabled] === true && (
                                        <KendoButton
                                            themeColor={'base'}
                                            onClick={() => {
                                                setShowZohoSignDialog(true);
                                            }}
                                        >
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                Zoho E-Sign
                                                <SvgIcon icon={downloadIcon} />
                                            </div>
                                        </KendoButton>
                                    )}
                                    {hasValue(combinedPrintPdf) && configuration?.featureFlags?.[FeatureFlagIds.SecureCloseEnabled] === true && (
                                        <KendoButton
                                            themeColor={'base'}
                                            onClick={() => {
                                                setShowSecureCloseDialog(true);
                                            }}
                                        >
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                SecureClose E-Sign
                                                <SvgIcon icon={downloadIcon} />
                                            </div>
                                        </KendoButton>
                                    )}
                                    {(configuration?.featureFlags?.[FeatureFlagIds.ZohoSignEnabled] === true || configuration?.featureFlags?.[FeatureFlagIds.SecureCloseEnabled] === true) && (
                                        <KendoButton
                                            themeColor={'base'}
                                            onClick={() => {
                                                setShowESignHistoryDialog(true);
                                            }}
                                        >
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                E-Sign History
                                            </div>
                                        </KendoButton>
                                    )}
                                </>
                            )}
                        </div>
                    </WindowActionsBar>
                </Window>
            )}
            {showDownPaymentDialog &&
                <DownPaymentDialog
                    vehicle={currentApp!.vehicle!}
                    configuration={configuration!}
                    lookups={lookups}
                    onClose={onDownPaymentClose}
                    downPaymentOnQuote={downPaymentOnQuote ?? 0}
                    balanceOnQuote={balanceOnQuote}
                    amountDeposited={totalDownPaymentAmountPaid}
                    onOpenCardPayments={() => {
                        onDownPaymentClose();
                        setShowCardPayments(true);
                    }}
                />
            }
            {showCardPayments && currentApp &&
                <CardPaymentsWindow
                    applicationId={currentApp.id}
                    onClose={() => setShowCardPayments(false)}
                />
            }
            {showZohoSignDialog && currentApp && (
                <ZohoSignDialog
                    applicationId={currentApp.id}
                    applicationNumber={currentApp.applicationNo?.toString()}
                    documentIds={selectedLoanDocumentIds.length > 0 
                        ? selectedLoanDocumentIds 
                        : loanDocuments.map(d => d.id)}
                    buyerName={(() => {
                        const buyer = currentApp.appCustomers.find(ac => 
                            ac.customerRoleId?.toUpperCase() === Constants.roleApplicantId
                        );
                        return buyer?.customer 
                            ? `${buyer.customer.firstName} ${buyer.customer.lastName}`.trim() 
                            : undefined;
                    })()}
                    buyerEmail={(() => {
                        const buyer = currentApp.appCustomers.find(ac => 
                            ac.customerRoleId?.toUpperCase() === Constants.roleApplicantId
                        );
                        const emails = buyer?.customer?.customerEmail;
                        return (emails?.find(e => e.isPreferred) ?? emails?.[0])?.emailAddress;
                    })()}
                    coBuyerName={(() => {
                        const cobuyer = currentApp.appCustomers.find(ac => 
                            ac.customerRoleId?.toUpperCase() === Constants.roleCoApplicant1Id
                        );
                        return cobuyer?.customer 
                            ? `${cobuyer.customer.firstName} ${cobuyer.customer.lastName}`.trim() 
                            : undefined;
                    })()}
                    coBuyerEmail={(() => {
                        const cobuyer = currentApp.appCustomers.find(ac => 
                            ac.customerRoleId?.toUpperCase() === Constants.roleCoApplicant1Id
                        );
                        const emails = cobuyer?.customer?.customerEmail;
                        return (emails?.find(e => e.isPreferred) ?? emails?.[0])?.emailAddress;
                    })()}
                    employeeName={`${activeUser.firstName} ${activeUser.lastName}`.trim()}
                    employeeEmail={activeUser.emailAddress}
                    onClose={() => setShowZohoSignDialog(false)}
                    onSuccess={(requestId) => {
                        dispatch(showErrorMessage(`Documents sent for e-signature successfully!`));
                    }}
                />
            )}
            {showESignHistoryDialog && currentApp && (
                <ESignHistoryDialog
                    applicationId={currentApp.id}
                    onClose={() => setShowESignHistoryDialog(false)}
                />
            )}
            {showPrintHistoryDialog && currentApp && (
                <PrintHistoryDialog
                    applicationId={currentApp.id}
                    onClose={() => setShowPrintHistoryDialog(false)}
                />
            )}
            {showSecureCloseDialog && currentApp && (
                <SecureCloseDialog
                    applicationId={currentApp.id}
                    applicationNumber={currentApp.applicationNo?.toString()}
                    documentIds={selectedLoanDocumentIds.length > 0 
                        ? selectedLoanDocumentIds 
                        : loanDocuments.map(d => d.id)}
                    documentNames={loanDocuments.map(d => ({ id: d.id, name: d.name }))}
                    buyerName={(() => {
                        const buyer = currentApp.appCustomers.find(ac => 
                            ac.customerRoleId?.toUpperCase() === Constants.roleApplicantId
                        );
                        return buyer?.customer 
                            ? `${buyer.customer.firstName} ${buyer.customer.lastName}`.trim() 
                            : undefined;
                    })()}
                    buyerEmail={(() => {
                        const buyer = currentApp.appCustomers.find(ac => 
                            ac.customerRoleId?.toUpperCase() === Constants.roleApplicantId
                        );
                        const emails = buyer?.customer?.customerEmail;
                        return (emails?.find(e => e.isPreferred) ?? emails?.[0])?.emailAddress;
                    })()}
                    coBuyerName={(() => {
                        const cobuyer = currentApp.appCustomers.find(ac => 
                            ac.customerRoleId?.toUpperCase() === Constants.roleCoApplicant1Id
                        );
                        return cobuyer?.customer 
                            ? `${cobuyer.customer.firstName} ${cobuyer.customer.lastName}`.trim() 
                            : undefined;
                    })()}
                    coBuyerEmail={(() => {
                        const cobuyer = currentApp.appCustomers.find(ac => 
                            ac.customerRoleId?.toUpperCase() === Constants.roleCoApplicant1Id
                        );
                        const emails = cobuyer?.customer?.customerEmail;
                        return (emails?.find(e => e.isPreferred) ?? emails?.[0])?.emailAddress;
                    })()}
                    employeeName={`${activeUser.firstName} ${activeUser.lastName}`.trim()}
                    employeeEmail={activeUser.emailAddress}
                    onClose={() => setShowSecureCloseDialog(false)}
                    onSuccess={(requestId) => {
                        dispatch(showErrorMessage(`Documents sent for e-signature via SecureClose successfully!`));
                    }}
                />
            )}

        </div >
    )
}

export default ApplicationDetailsCard;
